import React from 'react'
import { BroadCastIcon } from './BroadCastIcon'

import classes from './BroadCastBadge.module.scss'

export const BroadCastBadge = () => {
  return (
    <div className={classes.Container}>
      <BroadCastIcon />
      <span>Broadcast</span>
    </div>
  )
}
